import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/Button';

/** Bulk review actions on the open document's suggestions. */
export type BulkReviewAction = 'approve' | 'reject';

/** Bulk actions touching more pending suggestions than this ask first. */
export const BULK_CONFIRM_THRESHOLD = 10;

const COPY: Record<BulkReviewAction, { title: string; body: (n: number) => string; confirm: string }> = {
  approve: {
    title: 'Approve all pending suggestions?',
    body: (n) => `All ${n} pending suggestions on this document will be marked for redaction.`,
    confirm: 'Approve all',
  },
  reject: {
    title: 'Reject all pending suggestions?',
    body: (n) => `All ${n} pending suggestions on this document will be kept unredacted.`,
    confirm: 'Reject all',
  },
};

interface BulkReviewConfirmDialogProps {
  /** The action awaiting confirmation; null when closed. */
  action: BulkReviewAction | null;
  pendingCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function BulkReviewConfirmDialog({ action, pendingCount, onConfirm, onCancel }: BulkReviewConfirmDialogProps) {
  const copy = action ? COPY[action] : null;
  return (
    <Dialog open={!!copy} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        {copy && (
          <>
            <DialogHeader>
              <DialogTitle>{copy.title}</DialogTitle>
              <DialogDescription>{copy.body(pendingCount)}</DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button onClick={onConfirm}>{copy.confirm}</Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
